import React from 'react';
import { Box, Typography } from '@mui/material';
import { EmployeeAvatar } from '../../../../../../common/EmployeeAvatar';
import { getTemplateTypeConstant, MATRIX_TEMPLATE_TYPES } from '../../../../../../../constants/matrixTemplateTypes';
import { REVIEW_TYPES } from '../../../../../../../constants/reviewTypes';

const ReviewerFeedbackAction = ({ 
  reviewer, 
  comments,
  actionType,
  employeeId,
  assignment
}) => {
  const reviewType = reviewer.reviewType;
  const reviewTemplateType = getTemplateTypeConstant(reviewer.skillsMatrixTemplate.type);
  const isParallelReview = reviewType === REVIEW_TYPES.PARALLEL;

  const additionalInfo = isParallelReview 
    ? reviewTemplateType === MATRIX_TEMPLATE_TYPES.SELF_ASSESSMENT 
      ? 'Self Assessment' 
      : 'Evaluator' 
    : reviewer.order === 1 
      ? 'Self Assessment' 
      : `Reviewer ${reviewer.order}`;

  // Don't render if no comments
  if (!comments || !comments.trim()) {
    return null;
  }

  return (
    <Box sx={{ 
      mb: 2,
      p: 2,
      border: '1px solid #e0e0e0',
      borderRadius: 1,
      backgroundColor: '#f9f9f9'
    }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
        <EmployeeAvatar employee={reviewer.employee} size={32} />
        <Box>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {reviewer.employee.fullName}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {additionalInfo}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          backgroundColor: '#f9f9f9',
          border: '1px solid #e0e0e0',
          borderRadius: '4px',
          p: 2,
          minHeight: '40px',
          maxHeight: '200px',
          overflowY: 'auto',
          fontSize: '0.875rem',
          lineHeight: '1.5',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
          color: 'text.primary'
        }}
      >
        {comments}
      </Box>
    </Box>
  );
};

export default ReviewerFeedbackAction; 